var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.5V23C9.5 24.4001 9.5 25.1003 9.77249 25.635C10.0122 26.1054 10.3946 26.4879 10.865 26.7275C11.3998 27 12.0999 27 13.5 27H23C24.4001 27 25.1003 27 25.635 26.7275C26.1054 26.4879 26.4879 26.1054 26.7275 25.635C27 25.1003 27 24.4001 27 23V13.5C27 12.0999 27 11.3998 26.7275 10.865C26.4879 10.3946 26.1054 10.0122 25.635 9.77249C25.1003 9.5 24.4001 9.5 23 9.5H19.5M6 19.5H15.5C16.9001 19.5 17.6002 19.5 18.135 19.2275C18.6054 18.9879 18.9879 18.6054 19.2275 18.135C19.5 17.6002 19.5 16.9001 19.5 15.5V6C19.5 4.59987 19.5 3.8998 19.2275 3.36503C18.9879 2.89461 18.6054 2.51216 18.135 2.27249C17.6002 2 16.9001 2 15.5 2H6C4.59987 2 3.8998 2 3.36503 2.27249C2.89461 2.51216 2.51216 2.89461 2.27249 3.36503C2 3.8998 2 4.59986 2 6V15.5C2 16.9001 2 17.6002 2.27249 18.135C2.51216 18.6054 2.89461 18.9879 3.36503 19.2275C3.8998 19.5 4.59986 19.5 6 19.5Z",
    stroke: "#C4C4C4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.40f5fbca310aea7544f9796307e6b762.svg";
export { ForwardRef as ReactComponent };